import React, {useEffect,useState} from 'react';
import './App.css';
import AppRouting from './AppRouting.js';
import {Provider} from 'react-redux';
import {store} from './redux-store/store';
import {AuthProvider} from './hooks/AuthContext.js';
import {ThemeProvider,Dialog,DialogTitle,DialogContent,DialogActions,Button,Typography} from '@mui/material';
import {appTheme} from './shared/theme/muitheme.js';
import InstallPrompt from './components/PWA/InstallPrompt.jsx';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


// ============================================================
// APP
// ============================================================

function App() {

    const [updateAvailable,setUpdateAvailable] = useState(false);
    const [swRegistration,setSwRegistration] = useState(null);

    // ========================================================
    // REGISTER SERVICE WORKER
    // ========================================================

    useEffect(() => {
        serviceWorkerRegistration.register({
            // ------------------------------------------------
            // First installation
            // ------------------------------------------------
            onSuccess: (registration) => {
                console.log(
                    'Service Worker registered successfully:',
                    registration
                );
            },

            // ------------------------------------------------
            // New version detected
            // ------------------------------------------------

            onUpdate: (registration) => {
                console.log(
                    'NEW APPLICATION VERSION AVAILABLE'
                );
                console.log(
                    'Service Worker registration:',
                    registration
                );
                setSwRegistration(
                    registration
                );

                setUpdateAvailable(
                    true
                );
            }

        });

    }, []);


    // ========================================================
    // SERVICE WORKER CONTROLLER CHANGE
    // ========================================================

   useEffect(() => {
    let refreshing = false;
    const handleControllerChange = () => {
        if (refreshing) {
            return;
        }
        refreshing = true;
        console.log(
            'New Service Worker activated. Reloading application...'
        );
        window.location.reload();
    };
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.addEventListener(
            'controllerchange',
            handleControllerChange
        );
    }

    return () => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.removeEventListener(
                'controllerchange',
                handleControllerChange
            );
        }
    };

}, []);


    // ========================================================
    // UPDATE APPLICATION
    // ========================================================

    const handleUpdate = () => {
        console.log(
            'User clicked Update.'
        );
        if (
            !swRegistration
        ) {
            console.warn('Service Worker registration not found.');
            return;
        }

        if (
            swRegistration.waiting
        ) {
            console.log('Sending SKIP_WAITING to new Service Worker.');
            swRegistration.waiting.postMessage({
                type: 'SKIP_WAITING'
            });
            return;
        }
        console.warn('No waiting Service Worker found.');
    };

    // ========================================================
    // RENDER
    // ========================================================

    return (
        <Provider store={store}>
            <AuthProvider>
                <ThemeProvider theme={appTheme}>
                    <AppRouting />
                    <InstallPrompt />
                    {/* ========================================
                        UPDATE DIALOG
                    ======================================== */}
                    <Dialog
                        open={updateAvailable}
                        onClose={() =>
                            setUpdateAvailable(false)
                        }
                        maxWidth="sm"
                        fullWidth
                    >

                        <DialogTitle>
                            New Version Available
                        </DialogTitle>
                        <DialogContent>
                            <Typography>
                                A new version of the
                                application is available.
                                Would you like to update
                                now?
                            </Typography>
                        </DialogContent>

                        <DialogActions>

                            <Button
                                onClick={() =>
                                    setUpdateAvailable(
                                        false
                                    )
                                }
                            >
                                Later
                            </Button>


                            <Button
                                variant="contained"
                                onClick={
                                    handleUpdate
                                }
                                autoFocus
                            >
                                Update
                            </Button>
                        </DialogActions>
                    </Dialog>
                </ThemeProvider>
            </AuthProvider>
        </Provider>
    );
}


export default App;